import { GoogleOAuthProvider } from "@react-oauth/google";
import { createRoot } from "react-dom/client";
import "semantic-ui-less/semantic.less";

import App from "App";
import ENV from "config/Env";
import { TypedQueryClientProvider } from "hooks";
import "index.scss";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <TypedQueryClientProvider>
      <GoogleOAuthProvider clientId={ENV.clientID || ""}>
        <App />
      </GoogleOAuthProvider>
    </TypedQueryClientProvider>
  );
}
